<template>
  <div class="flex items-center gap-x-2 group cursor-pointer">
    <div class="shrink-0 size-8 group-hover:scale-110 transition-transform relative">
      <img
        :src="row.isFinalSlide ? row.finalSlideConfig?.image : row.image"
        class="size-full object-cover rounded-md shadow"
        :class="{ 'bg-gray-200': !getImageSrc(row) }"
      >
    </div>
  </div>
</template>

<script setup>

defineProps({
  row: {
    type: Object,
    default: () => {}
  }
});

function getImageSrc(row) {
  return row.isFinalSlide ? row.finalSlideConfig?.image : row.image;
}
</script>
